var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.53062,
    cy: 2.53062,
    r: 2.53062,
    transform: "matrix(-1 0 0 1 11.5308 6.90479)",
    stroke: "#2C1B73",
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8521 3.80888C14.1182 3.83076 14.3847 3.81008 14.6416 3.74952C14.9183 3.68428 15.2232 3.73371 15.4082 3.94961C16.084 4.73832 16.6167 5.65324 16.9661 6.65416C17.0718 6.95683 16.9182 7.2775 16.6708 7.48136C16.1075 7.9455 15.7483 8.64851 15.7483 9.4354C15.7483 10.2223 16.1075 10.9253 16.6708 11.3894C16.9182 11.5933 17.0718 11.914 16.9661 12.2167C16.6168 13.2175 16.0841 14.1323 15.4084 14.9209C15.2234 15.1369 14.9185 15.1863 14.6417 15.121C14.0363 14.9782 13.3772 15.057 12.796 15.3926C12.1634 15.7578 11.7482 16.3549 11.5956 17.0145C11.5315 17.2918 11.3518 17.5436 11.0758 17.6135C10.4117 17.7815 9.7163 17.8708 9 17.8708C8.28373 17.8708 7.58831 17.7815 6.92427 17.6135C6.64827 17.5437 6.46861 17.2919 6.40445 17.0145C6.3595 16.8201 6.29173 16.6312 6.2023 16.452M11.8311 2.48285C11.7251 2.28487 11.6461 2.07398 11.5957 1.85628C11.5315 1.57895 11.3519 1.32719 11.0759 1.25735C10.4118 1.08929 9.71634 1 9 1C8.28371 1 7.58827 1.08928 6.9242 1.25732C6.64823 1.32715 6.46858 1.57892 6.40441 1.85626C6.25181 2.51577 5.83659 3.11273 5.2041 3.4779C4.62289 3.81346 3.96389 3.89227 3.35845 3.7495C3.08171 3.68425 2.77685 3.73368 2.59184 3.94959C1.91602 4.73829 1.38328 5.65322 1.03386 6.65414C0.928192 6.95682 1.08179 7.27749 1.32921 7.48135C1.89254 7.94549 2.2517 8.64851 2.2517 9.4354C2.2517 10.2223 1.89254 10.9253 1.32921 11.3895C1.08178 11.5933 0.928191 11.914 1.03386 12.2167C1.38324 13.2175 1.9159 14.1323 2.59162 14.921C2.77663 15.1369 3.08153 15.1863 3.3583 15.121C3.64462 15.0535 3.94292 15.0355 4.23931 15.0708",
    stroke: "#2C1B73",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberSetting);
export default __webpack_public_path__ + "static/media/memberSetting.299a710929acb8bc3716ef0e3c8d2b57.svg";
export { ForwardRef as ReactComponent };